import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PublicBoxAuthorizeRequest {
  @jsonMember(String)
  public readonly password: string;

  public constructor(password: string) {
    this.password = password;
  }
}
